// TODO refactor when we add installments support via payment plan with CC
export const getInstallmentsFromPlan = paymentPlan => {
  return paymentPlan?.preferences?.kind === 'credit_card'
    ? paymentPlan?.preferences?.installments
    : paymentPlan?.config?.installments[0]?.times;
};
